import { LitElement, html, css } from 'lit'
import 'bui/elements/headers'
import 'bui/elements/icon'
import 'bui/elements/text'
import 'bui/presenters/form/handler'
import 'bui/presenters/form/controls/radio-group'
import 'bui/presenters/form/controls/radio-btn'

const ROUTE_DIRECTIONS = ['Round trip from', 'One-way from', 'One-way to']

customElements.define('s-bus-reserve-camper', class extends LitElement{

    static get listeners(){return {
        model: {'change:bus_route': 'requestUpdate'},
        routes: {'sync': 'requestUpdate'}
    }}

    static get styles(){return css`
        :host {
            display: block;
            position:relative;
        }

        .school {
            font-weight: normal;
        }
        
        b-h1, b-h2 {
            font-family: var(--font-header);
        }

        .school {
            font-family: inherit;
        }

        .routes {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 1em;
            margin-top: 1em;
        }

        .routes radio-btn {
            /* display: block; */
        }

        @media (max-width: 699px){
            b-h1 {
                font-size: 1.2em;
            }

            b-h2 {
                font-size: 1em;
            }

            .routes {
                grid-template-columns: 1fr;
            }
        }
    `}

    get routeOptions(){
        
        return [{label: 'No reservation', val: ''}].concat(this.routes.map(m=>{
            return {
                label: `<i>${m.get('direction')}</i> ${m.get('location')}&nbsp;<b style="float: right">$${m.get('price')}</b>`,
                val: m.id
            }
        }))
    }

    routeOptionsFor(direction){
        return this.routes.filter(route=>route.get('direction')==direction)
    }

    render(){return html`
        <b-h2><b-sub>Session ${this.model.get('session')}</b-sub></b-h2>
        <b-h1>${this.model.get('name')}</b-h1>
        <b-h2 class="school">${this.model.get('school')}</b-h2>

        ${this.model.get('bus_route')?html`
            <b-icon name="ok-circled"></b-icon> Bus reserved
        `:html`

            <form-handler class="routes" .validateChange=${this.validateChange} .onChange=${this.onChange.bind(this)}>
            ${ROUTE_DIRECTIONS.map(direction=>html`

                <div class="dir">
                    <b-text bold lg>${direction}:</b-text>
                    <radio-group key="${direction}">${this.routeOptionsFor(direction).map(route=>html`
                        <radio-btn value="${route.id}">
                            <span>
                                ${route.get('location')}
                                <b>$${route.get('price')}</b>
                            </span>
                        </radio-btn>
                    `)}
                    </radio-group>
                </div>

            `)}
            </form-hand>
        `}
        
    `}

    validateChange(m, changes, key, val){
        if( key == 'Round trip from' ){
            changes['One-way from'] = null
            changes['One-way to'] = null
        }else{
            changes['Round trip from'] = null
        }
    }

    onChange(changes){
        this.model.set('_bus_route', this.value)
    }

    get value(){
        return this.formHandler.editors.map(control=>control.value).filter(v=>v)
    }

})

export default customElements.get('s-bus-reserve-camper')